<div class="container">
  <ng-content select="span"></ng-content>
</div>
